import React, { memo } from 'react';
import styled from 'styled-components';

type PhotoProps = {
    children: React.ReactNode;
};

const Root = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    margin-top: 20px;

    img {
        width: 200px;
        height: auto;
    }
`;

const Photo = memo((props: PhotoProps): React.ReactElement => {
    const { children } = props;

    return <Root>{children}</Root>;
});

export { Photo };
